/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const accountModule = require('@utils/account/accountModule');
const commonModule = require('@utils/common/commonModule');
const cookiesModule = require('@utils/cookies/cookiesModule');
const cmsModule = require('@utils/cms/cmsModule');
const disclosureStatementDirective = require('./disclosureStatementDirective');
const DisclosuresModalService = require('./modals/disclosuresModalService');

const disclosuresModule = angular
    .module('enervee_utils.disclosures', [
        'ui.bootstrap',
        accountModule.name,
        commonModule.name,
        cookiesModule.name,
        cmsModule.name,
    ])
    .factory('DisclosuresModalService', DisclosuresModalService)
    .directive('disclosureStatement', disclosureStatementDirective);

module.exports = disclosuresModule;